/**
 * Logo - importa los assets directamente del package.
 * Vite resuelve la URL al build time y bundlea el archivo en cada SPA.
 * Una sola copia fisica vive en `packages/ui/assets/brand/`.
 */

import aosenumaIconWhite from '../../assets/brand/aosenuma-icon-white.png';
import aosenumaLogoColor from '../../assets/brand/aosenuma-logo-color.png';
import elawan from '../../assets/brand/elawan.png';
import elawanColor from '../../assets/brand/elawan-color.png';
import elawanColorLogin from '../../assets/brand/elawan-color-login.png';

const SRC = {
  'aosenuma-icon-white': aosenumaIconWhite,
  'aosenuma-logo-color': aosenumaLogoColor,
  elawan,
  'elawan-color': elawanColor,
  'elawan-color-login': elawanColorLogin,
} as const;

const ALT_DEFAULTS = {
  'aosenuma-icon-white': 'aosenuma',
  'aosenuma-logo-color': 'aosenuma',
  elawan: 'Elawan Energy',
  'elawan-color': 'Elawan Energy',
  'elawan-color-login': 'Elawan Energy · An ORIX Company',
} as const;

type Variant = keyof typeof SRC;

interface LogoProps {
  variant: Variant;
  height?: number | string;
  width?: number | string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function Logo({ variant, height, width, alt, className, style }: LogoProps) {
  return (
    <img
      src={SRC[variant]}
      alt={alt ?? ALT_DEFAULTS[variant]}
      height={height}
      width={width}
      className={className}
      style={{ objectFit: 'contain', ...style }}
    />
  );
}
